import { ArcxApi } from './ArcxApi'

export type Services = ReturnType<typeof createServices>

export function createServices() {
  const arcxApi = new ArcxApi('https://arcx-api-mainnet.herokuapp.com')
  return {
    arcxApi,
  }
}
